import {createContext, useContext} from 'react';
export const ManagerContext = createContext(null);
export const useManagerContext = () => useContext(ManagerContext);
